import { StorageStatusDto } from 'src/Libs/storage'
import { determineIsStorageOnline } from '../../utils/installation-online'

/**
 * Uses the time property (last time installation has been online) to determine the installation's online status.
 */
const fromStorageStatusDtoToIsOnline = (dto: StorageStatusDto): boolean => {
  return determineIsStorageOnline(dto.time)
}

export default fromStorageStatusDtoToIsOnline
